///APP SEARCH
import axios from 'axios';

export default {
    namespaced: true,
    state: {
        searchList: {},
        recentSearch: []
    },
    mutations: {
        setRecentSearch(state,val){
            state.recentSearch = val;
        }
    },
    actions: {
        getSearch(store, val){
            if (val){
                const url = store.rootState.shared.api_url;
                const data = {
                    keyword: val
                };
                axios.post(url + "keywords", data)
                        .then(response=>{
                            if (Object.keys(response.data).length){
                                store.state.searchList = response.data
                            }else {
                                store.state.searchList = {nothing: true}
                            }
                        })
                        .catch(error=>console.log(error));
            }else{
                store.state.searchList = {nothing: false}
            }
        }

    },
    getters: {}
}
